import { render, staticRenderFns } from "./CodiGenerator.vue?vue&type=template&id=370854b6&"
import script from "./CodiGenerator.vue?vue&type=script&lang=js&"
export * from "./CodiGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports